var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-input-file',{staticClass:"media-file-add-button",attrs:{"multiple":"","accept":_vm.allowedFileTypes},on:{"input":function (files) { return _vm.$emit('input', files); }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var selectFile = ref.selectFile;
return [_c('base-thumbnail-button',{attrs:{"title":_vm.title,"mobileHideText":_vm.mobileHideText},on:{"click":selectFile}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }